<div class="content">
   <div class="header">
      <button type="button" class="close-btn" (click)="fecharModal()">
         <span></span>
         <span></span>
      </button>
   </div>

   <div id="iFrame" class="content-iframe">
      <iframe [src]="linkRelatorio" sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-popups-to-escape-sandbox allow-downloads allow-storage-access-by-user-activation" frameborder="0" width="100%" height="100%"></iframe> 
   </div>
</div>